export default {
  common: {
    nav: {
      home: "ಮುಖಪುಟ",
      find_offer_help: "ಸಹಾಯ ಹುಡುಕಿ / ಒದಗಿಸಿ",
      celebrate: "ಜೀವನವನ್ನು ಆಚರಿಸಿ",
      family_tree: "ಕುಟುಂಬ ವೃಕ್ಷ",
      events: "ಕಾರ್ಯಕ್ರಮಗಳು",
      civic_reports: "ನಾಗರಿಕ ವರದಿಗಳು",
      neighborhood_pulse: "ನೆರೆಹೊರೆಯ ಸ್ಪಂದನ",
      weather: "ಹವಾಮಾನ",
      nature: "ಪ್ರಕೃತಿ",
      marketplace: "ಮಾರುಕಟ್ಟೆ",
      news: "ಸುದ್ದಿ",
      causes: "ಉದ್ದೇಶಗಳು",
      more: "ಇನ್ನಷ್ಟು",
    },
    header: { sign_in: "ಸೈನ್ ಇನ್", join: "Social Pulse ಸೇರಿ", language: "ಭಾಷೆ", search: "ಹುಡುಕು" },
    tagline: "ಸಮುದಾಯಗಳನ್ನು ಸಂಪರ್ಕಿಸುವುದು · ಜೀವನಗಳಿಗೆ ಶಕ್ತಿ ನೀಡುವುದು · ಸಾಮಾಜಿಕ ಬಂಡವಾಳ ಕಟ್ಟುವುದು",
    locality: { viewing_from: "ನೀವು ವೀಕ್ಷಿಸುತ್ತಿರುವುದು", change: "ಬದಲಿಸಿ", set_your_location: "ನಿಮ್ಮ ಸ್ಥಳವನ್ನು ಹೊಂದಿಸಿ" },
    news: { title: "ನಿಮ್ಮ ದೈನಂದಿನ ಸಾರಾಂಶ.", play_briefing: "ದೈನಂದಿನ ಸಾರಾಂಶವನ್ನು ಪ್ಲೇ ಮಾಡಿ", listen: "ಕೇಳಿ", translate: "ಅನುವಾದಿಸಿ" },
  },
};
